import { buildFormSchemaForCarriers, buildPortalContractSchemaForCarriers, FieldType, isFieldRequired, isFieldVisible, } from "./forms.js";
function isEmptyValue(field, value) {
    if (value === undefined || value === null || value === "")
        return true;
    if (field.type === FieldType.CHECKBOX_GROUP && Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (field.type === FieldType.CHECKBOX && !value)
        return true;
    if (field.type === FieldType.SIGNATURE && !value)
        return true;
    if (field.type === FieldType.FILE) {
        if (typeof value !== "object")
            return true;
        const file = value;
        return typeof file.fileId !== "string" || !file.fileId.trim();
    }
    return false;
}
function stringValue(value) {
    return typeof value === "string" ? value.trim() : String(value ?? "").trim();
}
function validateFieldValue(field, value, today) {
    if (isEmptyValue(field, value)) {
        return `${field.label} is required`;
    }
    const text = stringValue(value);
    if (field.validation?.minLength !== undefined && text.length < field.validation.minLength) {
        return `${field.label} must be at least ${field.validation.minLength} characters`;
    }
    if (field.validation?.maxLength !== undefined && text.length > field.validation.maxLength) {
        return `${field.label} must be at most ${field.validation.maxLength} characters`;
    }
    if (field.validation?.pattern) {
        const regex = new RegExp(field.validation.pattern);
        if (!regex.test(text)) {
            return `${field.label} format is invalid`;
        }
    }
    if (field.type === FieldType.DATE && field.validation?.custom === "pastDate") {
        const date = new Date(text);
        date.setHours(0, 0, 0, 0);
        if (Number.isNaN(date.getTime()) || date >= today) {
            return `${field.label} must be in the past`;
        }
    }
    if (field.type === FieldType.EMAIL && text) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(text)) {
            return `${field.label} must be a valid email address`;
        }
    }
    return null;
}
function validateFormDataAgainstSchema(formData, schema) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return schema.sections.flatMap((section) => section.fields.flatMap((field) => {
        if (!isFieldVisible(field, formData))
            return [];
        const value = formData[field.id];
        const required = isFieldRequired(field, formData);
        if (required && isEmptyValue(field, value)) {
            return [{
                    fieldId: field.id,
                    label: field.label,
                    message: `${field.label} is required`,
                    sectionId: section.id,
                }];
        }
        if (isEmptyValue(field, value))
            return [];
        const message = validateFieldValue(field, value, today);
        if (!message)
            return [];
        return [{
                fieldId: field.id,
                label: field.label,
                message,
                sectionId: section.id,
            }];
    }));
}
export function validateFormData(formData, carriers = []) {
    return validateFormDataAgainstSchema(formData, buildFormSchemaForCarriers(carriers));
}
/** Validates an authenticated portal submission without public identity fields. */
export function validatePortalSubmissionForm(formData, carriers = []) {
    return validateFormDataAgainstSchema(formData, buildPortalContractSchemaForCarriers(carriers));
}
